const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the content picker component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
*/
app.directive('userProgress', [function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      type: '@',
      progress: '@',
      total: '@',
      users: '@',
      content: '@'
    },
    template: require('../../templates/directives/user-progress.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.isComplete = false;

      self.init = function(){
        self.type = $scope.type;
        self.progress = 0;
        self.noAssignments = false;
        self.notStarted = false;
        self.total = $scope.total ? parseInt($scope.total) : 0;
        self.progress = $scope.progress ? parseInt($scope.progress) : 0;
        
        if (self.type === 'count') {
          if (self.total && self.progress) {
            self.progress = Math.floor((self.progress / self.total * 100));
          }
        };

        if (self.type === 'percent') {
          if (self.progress) {
            self.progress = Math.floor(self.progress);
          }
        };

        if (!self.progress) {
          if ($scope.users && !self.total) {
            self.noAssignments = true;
          }
          if (!$scope.users) {
            self.notStarted = true;
          }
        }
      };

      self.init();

      $scope.$watch('progress', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          self.init();
        }
      });
      $scope.$watch('total', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          self.init();
        }
      });
    }],
    controllerAs: 'userprogress'
  };
}]);
